var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    id: "Filled_Outline",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,19c-2.76,0-5-2.24-5-5s2.24-5,5-5c0-4.42,3.58-8,8-8c3.75,0,6.89,2.57,7.76,6.05   C26.71,7.42,29,9.95,29,13c0,3.31-2.69,6-6,6H8z",
    fill: "#7CA7C6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.5 -0.866 0.866 0.5 -15.6507 22.4283)",
    width: 6.393,
    x: 8.402,
    y: 23.768
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -21.8476 22.431)",
    width: 2,
    x: 7.5,
    y: 29.134
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.5 -0.866 0.866 0.5 -13.1507 26.7584)",
    width: 6.393,
    x: 13.402,
    y: 23.768
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -19.3472 26.7614)",
    width: 2,
    x: 12.5,
    y: 29.134
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -10.6501 31.0916)",
    width: 6.393,
    x: 18.402,
    y: 23.768
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -16.8468 31.0918)",
    width: 2,
    x: 17.5,
    y: 29.134
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.547,6.173C23.342,2.507,19.917,0,16,0c-4.651,0-8.489,3.545-8.953,8.076C4.19,8.534,2,11.016,2,14    c0,3.309,2.691,6,6,6h7v-2H8c-2.206,0-4-1.794-4-4s1.794-4,4-4c0.552,0,1-0.448,1-1c0-3.86,3.14-7,7-7    c3.219,0,6.011,2.176,6.79,5.292c0.1,0.4,0.436,0.698,0.846,0.75C26.124,8.354,28,10.486,28,13c0,2.757-2.243,5-5,5h-2v2h2    c3.86,0,7-3.14,7-7C30,9.706,27.699,6.882,24.547,6.173z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1A1A",
    height: 2,
    width: 2,
    x: 17,
    y: 18
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.0820b0250fd5aaa5cef7599eb3d11829.svg";
export { ForwardRef as ReactComponent };